// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferedTab_container__WpSPn","title":"OfferedTab_title__w2okR","divider":"OfferedTab_divider__oHV1T","card":"OfferedTab_card__ljxGz"};